module.exports = __webpack_public_path__ + "static/media/  (146).2decde37.jpg";